/**
 * issue #44 Phase γ-A/B: ユーザ入力のページ範囲文字列を [[start, end], ...] にパース。
 *
 * 受理する入力:
 * - 単一ページ: "3" → [[3, 3]]
 * - 範囲: "1-5" → [[1, 5]]
 * - 複数 (カンマ区切り、 空白許容): "1-5, 7-9" → [[1, 5], [7, 9]]
 *
 * 不正な入力 (非数字 / 0 以下 / 逆順 / 一部不正) は null を返す。
 * 空文字は「未指定」として null を返し、 上位で「全ページ処理」へフォールバック想定。
 */
export function parsePageRange(input: string): number[][] | null {
  if (!input.trim()) return null;
  const ranges: number[][] = [];
  for (const seg of input.split(',')) {
    const m = seg.trim().match(/^(\d+)(?:-(\d+))?$/);
    if (!m) return null;
    const start = parseInt(m[1], 10);
    const end = m[2] ? parseInt(m[2], 10) : start;
    if (start < 1 || end < start) return null;
    ranges.push([start, end]);
  }
  return ranges;
}
